module.exports = __webpack_public_path__ + "img/page_bg_onlineDrainage.22fe30ba.png";